import { render } from "./VanillaF.vue?vue&type=template&id=289842a5&scoped=true"
import script from "./VanillaF.vue?vue&type=script&lang=js"
export * from "./VanillaF.vue?vue&type=script&lang=js"

import "./VanillaF.vue?vue&type=style&index=0&id=289842a5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289842a5"]])

export default __exports__